import React, { useEffect, useRef, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'

import TreeList, { Column, SearchPanel, Scrolling, TreeListRef } from 'devextreme-react/tree-list'
import Tooltip from 'devextreme-react/tooltip'

import { RootState } from 'slices'
import { loadObjects } from 'slices/objects'
import { settingsMenuSelector } from 'slices/ui'
import { SettingType } from 'helpers/setting-type-enum'

import { DrawerState } from 'helpers/drawer-state-enum'

import { useIxAuth } from 'contexts/auth-context'
import { useUserSettingsUpdate } from 'hooks'
import { zeroPad } from 'helpers/zero-pad'
import { Settings } from 'helpers/settings-enum'

import './drawer-objects-list.scss'

type IDrawerObjectsListProps = {
    searchValue: string,
}

export const DrawerObjectsList = ({ searchValue }: IDrawerObjectsListProps) => {
    const treeList = useRef<TreeListRef>(null)
    const { user } = useIxAuth()
    const { drawerState } = useSelector((state: RootState) => state.ui)
    const {value: ixCommonRuntime, id: ixCommonRuntimeId} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.ixCommonRuntime))

    const { objects, status } = useSelector((state: RootState) => state.objects)
    const dispatch = useAppDispatch()
    const storeCommonRuntimeData = useUserSettingsUpdate()

    useEffect(() => {
        // if user is not logged yet delay the dispatch
        if (!user || status !== 'idle' || (status === 'idle' && objects.length)) { return }
        dispatch(loadObjects())
    }, [dispatch, user, objects, status])

    useEffect(() => {
        /* v8 ignore next */
        if (treeList.current && searchValue !== undefined) {
            treeList.current.instance().searchByText(searchValue)
        }
    }, [searchValue, treeList])

    const cellClick = useCallback((e: any) => {
        const data = {...ixCommonRuntime, objNr: e.data.OBJNR, objNrFibu: e.data.FIBUNR, objNrId: e.data.HDR_ID}
        storeCommonRuntimeData('common-run-time', Settings.ixCommonRuntime, data, ixCommonRuntimeId, SettingType.GlobalSetting)

    },[storeCommonRuntimeData, ixCommonRuntime, ixCommonRuntimeId])


    const cellRender = (cell: any) => {
        return (
            <div id={`objNumber-${cell.value}`} className='objNumber--content'>
                {zeroPad(cell.value, 5)}
                {/* {cell.value} */}
                {
                    drawerState === DrawerState.Compact
                        ? (
                            <Tooltip target={`#objNumber-${cell.value}`} position='right' showEvent={{name: 'dxhoverstart', delay: 200}} hideEvent={{name: 'dxhoverend', delay: 200}}>
                                <p>{cell.data.NAME}</p>
                            </Tooltip>
                        )
                        : null
                }
            </div>
        )
    }

    return (
        <TreeList
            ref={treeList}
            keyExpr='HDR_ID'
            dataSource={objects}
            showColumnHeaders={false}
            showColumnLines={false}
            showBorders={false}
            showRowLines={false}
            repaintChangesOnly={true}
            dataStructure='plain'
            height={`${window.innerHeight-100}px`}
            className='drawerObjectList'
            onCellClick={cellClick}
            selectedRowKeys={ixCommonRuntime && ixCommonRuntime.objNrId ? [ixCommonRuntime.objNrId] : []}
        >

            <SearchPanel
                visible={false}
                highlightSearchText={false} />

            <Scrolling mode='virtual'/>

            <Column alignment='right' minWidth={0} width='auto' allowSearch={true} cssClass='objNumber' dataField='OBJNR' dataType='number' cellRender={cellRender} />
            <Column alignment='left' minWidth={0} allowSearch={true} cssClass='objName' dataField='O_ID' dataType='string' />
        </TreeList>
    )
}
